import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';
import { STORAGE_KEYS, API_CONFIG } from '../helpers/constants';

const Logout: React.FC = () => {
  const { logout } = useAuth();
  const { showSuccess } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    // Perform logout
    const performLogout = async () => {
      try {
        // Call backend logout endpoint
        const refreshToken = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
        if (refreshToken) {
          await fetch(`${API_CONFIG.BASE_URL}/auth/logout`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ refreshToken }),
          });
        }
      } catch (error) {
        console.error('Backend logout error:', error);
      } finally {
        // Always perform frontend logout
        logout();
      }
    };

    performLogout();
    
    // Show success message
    showSuccess('Successfully logged out');
    
    // Redirect to login page after a short delay
    const timer = setTimeout(() => {
      navigate('/login', { replace: true });
    }, 1000);

    return () => clearTimeout(timer);
  }, [logout, navigate, showSuccess]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
      }}
    >
      <CircularProgress size={40} />
      <Typography variant="h6" color="text.secondary">
        Logging out...
      </Typography>
    </Box>
  );
};

export default Logout; 